export const PUBLIC_PAGES = ["/cart", "/cart/payment"] as readonly string[];

export const AUTH_ROUTE_EXCEPTIONS = [
  "/auth/register/completion",
  "/auth/forget/change"
] as readonly string[];

export const EXAM_MANAGEMENT_PATHS = [
  "/exam-management/simplified/",
  "/exam-management/simplified"
] as readonly string[];
